//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region Angular Imports

import { IAngularEvent } from 'angular'
import { StateService } from "@uirouter/angularjs"

//#endregion

import { i18n } from '../i18n/common.i18n'
import { Permissions } from '../../../helpers/permissions'

import { IUserSession, ReferenceTypeComponent, DataTypeGroupComponent, LogHelper, EventsNames, CommonHelper, OperatorLayoutSettings, ConvertHelper } from '../../../helpers'
import { Enums, Activity } from '../../../models/common'
import { IReferenceType, IOpObject } from '../../../models/util/interfaces'
import { OpDataTypeInGroup, OpDataType } from '../../../models/core'

import { SERVICE_NAME as SYSTEM_SERVICE_NAME, SystemService, RegisterDetailsComponentOptions, SystemTargetService, SYSTEM_TARGET_SERVICE_NAME, SYSTEM_CONTEXT_LIST_SERVICE_NAME, SystemContextListService } from '../../../services/system'

import { CommonCreateEdit, CreateEditSection } from '../common.create-edit'
import { CreateEditInitParams, BulkEditInitParams } from '../create-edit-popup/create-edit-popup.controller'
import { DetailsOptions } from '../details-popup/details-popup.directive'

//#region Asset Imports

import './layout.scss'
import * as TEMPLATE from './layout.tpl.html'

//#endregion


export class LayoutDirective implements ng.IDirective {

    // Consts

    private static get LOG_PREFIX(): string { return '[SIMAX.Common.Layout]' }

    // Consts End

    protected userSession: IUserSession

    private $compile: ng.ICompileService
    private $scope: ng.IScope
    private $timeout: ng.ITimeoutService
    private componentContainer: JQuery
    private systemService: SystemService
    private systemTargetService: SystemTargetService
    private systemContextListService: SystemContextListService

    scope = {
        heightFillDisable: '=?',
        disablePadding: '=?',
    }

    controller = ['$compile', '$element', '$scope', '$timeout', '$state', 'userSession', SYSTEM_SERVICE_NAME, SYSTEM_TARGET_SERVICE_NAME, SYSTEM_CONTEXT_LIST_SERVICE_NAME, (
        $compile: ng.ICompileService,
        $element: JQuery,
        $scope: ng.IScope,
        $timeout: ng.ITimeoutService,
        $state: StateService,
        userSession: IUserSession,
        systemService: SystemService,
        systemTargetService: SystemTargetService,
        systemContextListService: SystemContextListService
    ) => {
        this.systemService = systemService
        this.systemTargetService = systemTargetService
        this.$compile = $compile
        this.$scope = $scope
        this.$timeout = $timeout
        this.componentContainer = $element.find('[data-component-container]')
        this.systemContextListService = systemContextListService
        this.userSession = userSession

        if (this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MAIN_MENU_VIEW)) {
            $scope['smallMenu'] = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.SmallMenuVisibility, false)

            if ($('html').width() < 768)
                $scope['smallMenu'] = true


            $scope.$watchCollection(() => {
                return window['MenuItems']
            }, val => {
                $scope['isSidebarMenuVisible'] = val.length > 1
            })


            $scope.$watch('smallMenu', () => {
                OperatorLayoutSettings.setSetting(OperatorLayoutSettings.SmallMenuVisibility, $scope['smallMenu'])
            })

            $scope['toggleMenu'] = () => {
                $scope['smallMenu'] = !$scope['smallMenu']
                $scope.$root.$broadcast('updateMeasurements')
            }
        }

        var detailsQueue = []

        var openDetailsOrModule = (args: any[]) => {
            const typeOrParams: number | DetailsOptions = args[0]

            if (typeof typeOrParams === 'number') {
                var referenceType: number = args[0]
                var referenceData: number[] = args[1]
                var openDetail: number = args[2] ? referenceData.indexOf(args[2]) : -1
                var activeTab: string = args[3]

                if (referenceType && _.size(referenceData) > 0) {
                    var moduleName = this.getRouterStateNameByIdReferenceType(referenceType)
                    Permissions.runIfHasPermissions(this.getModulePermissionsById(referenceType), () => {
                        if (referenceData.length == 1 || openDetail > -1) {
                            var popupEventName: string = this.getModuleDetailsEventNameById(referenceType)
                            _.defer(() => { $scope.$apply() })
                            if (openDetail == -1) openDetail = 0

                            this.insertComponent(moduleName, popupEventName, referenceData[openDetail], referenceData, activeTab)
                        } else {
                            $state.go(moduleName, { ids: referenceData })
                        }
                    })
                }
            } else {
                const openParams = typeOrParams
                const referenceObject = typeOrParams.referenceObject
                const referenceObjectIds = openParams['referenceObjectIds']
                const referenceObjectId: number = (_.first(referenceObjectIds) || openParams.referenceObjectId || (openParams.pageItemsIds != null ? _.first(openParams.pageItemsIds) : null)) as number
                const resultCallback = args[1];

                if (_.size(referenceObjectIds) > 0) {
                    const moduleName = this.getRouterStateNameBySimaxModuleName(openParams.moduleName)

                    $state.go(moduleName, { ids: referenceObjectIds })
                }
                else if (_.isNumber(referenceObjectId)) {
                    const popupEventName = EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, openParams.moduleName)
                    const directiveVisibleFlag = this.createShowDetailsDirectiveFlag(openParams)

                    openParams.referenceObjectId = referenceObjectId

                    _.defer(() => { $scope.$apply() })

                    this.insertComponent(directiveVisibleFlag, popupEventName, referenceObjectId, openParams.pageItemsIds, openParams.activeTab, openParams, resultCallback)
                }
                else if (referenceObject != null) {
                    const popupEventName = EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, openParams.moduleName)
                    const directiveVisibleFlag = this.createShowDetailsDirectiveFlag(openParams)

                    _.defer(() => { $scope.$apply() })

                    this.insertComponent(directiveVisibleFlag, popupEventName, referenceObjectId, openParams.pageItemsIds, openParams.activeTab, openParams, resultCallback)
                }
            }
        }

        // 
        this.initializeOpenTarget()

        $scope.$on(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, (event: IAngularEvent, ...args: any[]) => {
            if (args && args[0]) {
                const createEditInitParams: CreateEditInitParams = args[0]
                const referenceType: Enums.ReferenceType = ReferenceTypeComponent.getReferenceTypeByModule(createEditInitParams.moduleName)

                if (referenceType != Enums.ReferenceType.None) {
                    let directiveVisibleFlag: string = this.createShowCreateEditDirectiveFlag(createEditInitParams)

                    if (createEditInitParams.dedicatedForm != null) {
                        directiveVisibleFlag = createEditInitParams.dedicatedForm.replace(/-/gi, '_')
                    }
                    $scope[directiveVisibleFlag] = true

                    $timeout(() => {
                        const deferred: JQueryDeferred<IReferenceType & IOpObject> = $.Deferred<IReferenceType & IOpObject>()

                        if (_.isFunction(createEditInitParams.referenceObjectRequest)) {
                            createEditInitParams
                                .referenceObjectRequest()
                                .then((result: IReferenceType & IOpObject) => {
                                    deferred.resolve(result)
                                })
                                .catch(error => deferred.reject(error))
                        }
                        else if (createEditInitParams.referenceObject != null) {// referenceObject exist (edit)
                            deferred.resolve(createEditInitParams.referenceObject)
                        }
                        else if (createEditInitParams.referenceObjectId > 0) { // we need download referenceObject by referenceObjectId (edit)
                            ReferenceTypeComponent
                                .getReferenceObject(this.userSession.getDataProvider(), referenceType, createEditInitParams.referenceObjectId)
                                .then((result: IReferenceType) => deferred.resolve(<IReferenceType & IOpObject>result))
                                .catch(error => deferred.reject(error))
                        }
                        else { // referenceObject is new (create)
                            deferred.resolve(null)
                        }

                        this.systemService.showLoadIndicator();

                        deferred
                            .promise()
                            .then((loadedReferenceObject: IReferenceType & IOpObject) => {

                                $.when(
                                    this.getParamsToEdit(createEditInitParams),
                                    this.getGridParams(createEditInitParams),
                                    this.getRequiredParams(createEditInitParams),
                                    this.getCopySkipParams(createEditInitParams)
                                )
                                    .then((panelParamsToEdit: OpDataTypeInGroup[], gridParamsToEdit: OpDataTypeInGroup[], paramsRequired: OpDataTypeInGroup[], copySkipParams: OpDataTypeInGroup[]) => {
                                        const sections: CreateEditSection[] = []

                                        sections.push({
                                            name: i18n("Common", "Basics"),
                                            type: CommonCreateEdit.ReferenceObjectBaseParams,
                                            dataTypesToEdit: panelParamsToEdit,
                                            dataTypesRequired: paramsRequired
                                        })

                                        if (gridParamsToEdit != null && gridParamsToEdit.length > 0) {
                                            sections.push({
                                                name: i18n("Common", "Specifics"),
                                                type: CommonCreateEdit.ReferenceObjectExtendedParams,
                                                dataTypesToEdit: gridParamsToEdit,
                                                dataTypesRequired: paramsRequired
                                            })
                                        }

                                        createEditInitParams.sections = sections
                                        createEditInitParams.referenceObject = loadedReferenceObject

                                        if (createEditInitParams.isCopy) {
                                            _.forEach(sections, (section: CreateEditSection) => {
                                                section.dataTypesToEdit = _.filter(section.dataTypesToEdit, (dataType: OpDataTypeInGroup) => {
                                                    return _.find(copySkipParams, (copySkipParam: OpDataTypeInGroup) => {
                                                        return copySkipParam.idDataType === dataType.idDataType
                                                    }) == null
                                                })
                                            })

                                            if (createEditInitParams.referenceObject != null && createEditInitParams.referenceObject.dataList != null) {
                                                _.forEach(copySkipParams, (copySkipParams: OpDataTypeInGroup) => {
                                                    createEditInitParams.referenceObject.dataList.removeValue(copySkipParams.idDataType)
                                                })
                                            }
                                        }

                                        if (createEditInitParams.dedicatedForm == null) {
                                            $scope.$broadcast(
                                                EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_CREATE_EDIT_POPUP, createEditInitParams.moduleName),
                                                createEditInitParams,
                                                args[1]
                                            )
                                        } else {
                                            $scope.$broadcast(
                                                `${directiveVisibleFlag.toUpperCase()}_OPEN_POPUP`,
                                                createEditInitParams
                                            )
                                        }
                                    })
                            })
                            .always(() => {
                                this.systemService.hideLoadIndicator();
                            });
                    })
                }
            } else {
                console.log("INITIALIZE_CREATE_EDIT_POPUP empty init params")
            }
        })

        $scope.$on(EventsNames.INITIALIZE_BULK_EDIT_POPUP, (event, ...args: any[]) => {
            if (args && args[0]) {
                var bulkEditInitParams: BulkEditInitParams = args[0]
                var referenceType: Enums.ReferenceType = ReferenceTypeComponent.getReferenceTypeByModule(bulkEditInitParams.moduleName)

                if (referenceType != Enums.ReferenceType.None) {
                    var directiveVisibleFlag = this.createShowCreateEditDirectiveFlag(bulkEditInitParams)

                    $scope[directiveVisibleFlag] = true

                    $timeout(() => {
                        const paramsToEditPromise = bulkEditInitParams.customDataTypes && bulkEditInitParams.customDataTypes.paramsToEdit
                            ? this.createDataTypesInGroups(bulkEditInitParams.customDataTypes.paramsToEdit)
                            : DataTypeGroupComponent.getDataTypeInGroupByModule(this.userSession.getDataProvider(), Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PANEL_PARAMS_TO_EDIT, bulkEditInitParams.moduleName, bulkEditInitParams.groupReferenceType, bulkEditInitParams.groupReferenceValue)

                        const paramsRequiredPromise = bulkEditInitParams.customDataTypes && bulkEditInitParams.customDataTypes.paramsRequired
                            ? this.createDataTypesInGroups(bulkEditInitParams.customDataTypes.paramsRequired)
                            : DataTypeGroupComponent.getDataTypeInGroupByModule(this.userSession.getDataProvider(), Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PARAMS_REQUIRED, bulkEditInitParams.moduleName, bulkEditInitParams.groupReferenceType, bulkEditInitParams.groupReferenceValue)

                        $.when(paramsToEditPromise, paramsRequiredPromise)
                            .then((panelParamsToEdit: OpDataTypeInGroup[], paramsRequired: OpDataTypeInGroup[]) => {
                                var section: CreateEditSection = {
                                    name: i18n("Common", "Basics"),
                                    type: CommonCreateEdit.ReferenceObjectBulkParams,
                                    dataTypesToEdit: panelParamsToEdit,
                                    dataTypesRequired: paramsRequired
                                }

                                bulkEditInitParams.section = section

                                $scope.$broadcast(
                                    EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_BULK_EDIT_POPUP, bulkEditInitParams.moduleName),
                                    bulkEditInitParams,
                                    args[1]
                                )
                            })
                    })
                }
            } else {
                console.log("INITIALIZE_BULK_EDIT_POPUP empty init params")
            }
        })

        // details or module
        $scope['detailsPopupId'] = new Date().getTime()
        $scope.$on(EventsNames.OPEN_DETAILS_OR_MODULE, (event, ...args: any[]) => {
            detailsQueue.push(args)
            $scope['level'] = detailsQueue.length
            openDetailsOrModule(args)
        })

        // $scope.$on

        // !!!TODO zmiana nazwy
        $scope.$on(EventsNames.CLOSED_POPUP + 'New', (...args: any[]) => {
            this.removeComponent(args[1])
        })

        $scope.$on(EventsNames.CLOSED_POPUP, (event, ...args: any[]) => {
            var restore: boolean = args[0] || false
            if (restore) {
                detailsQueue.pop()
                $scope['level'] = detailsQueue.length
            }
        })

        this.getDestinationPopupOptions()
    }]

    private getDestinationPopupOptions(): void {
        this.$scope['destinationPopupId'] = this.systemContextListService.getDestinationPopupId()
        this.$scope['destinationPopupOptions'] = this.systemContextListService.getPopupOptions()
    }

    private createShowCreateEditDirectiveFlag(params: BulkEditInitParams | CreateEditInitParams) {
        var referenceType: Enums.ReferenceType = ReferenceTypeComponent.getReferenceTypeByModule(params.moduleName)

        return 'showEdit_' + Enums.SimaxModuleName[params.moduleName] + '_' + Enums.ReferenceType[referenceType]
    }

    private createShowDetailsDirectiveFlag(params: DetailsOptions) {
        var referenceType: Enums.ReferenceType = ReferenceTypeComponent.getReferenceTypeByModule(params.moduleName)

        return Enums.SimaxModuleName[params.moduleName] + '_' + Enums.ReferenceType[referenceType]
    }

    private createDataTypesInGroups(dataTypes: Enums.DataType[]): JQueryPromise<OpDataTypeInGroup[]> {
        return this.userSession
            .getDataProvider().DataType
            .getDataTypes(dataTypes)
            .then((dataTypes: OpDataType[]) => {
                return dataTypes.map((dataType: OpDataType) => {
                    const group = new OpDataTypeInGroup(null)

                    group.idDataType = dataType.idDataType
                    group.dataType = dataType

                    return group
                })
            })
    }

    private insertComponent(flag: string, eventName: string, ...args: any[]): void {
        const componentId: string = flag + new Date().getTime().toString()
        const currentComponentInfo = _.find(this.systemService.getDetailsComponentOptions(), (options: RegisterDetailsComponentOptions) => {
            return options.key === flag
        })

        if (currentComponentInfo != null) {
            const componentName: string = ConvertHelper.stringToSnakeCase(currentComponentInfo.componentName);
            const template = `<${componentName} data-popup-manager-id="${componentId}" id="'${componentId}'" level="level"></${componentName}>`

            this.componentContainer.append(this.$compile(template)(this.$scope));

            this.$timeout(() => {
                this.$scope.$broadcast(eventName + componentId, ...args)
            }, 100)
        }
        else {
            LogHelper.warn(LayoutDirective.LOG_PREFIX, `Unable to find component info for flag: ${flag}.`)
        }
    }

    private removeComponent(componentId: string): void {
        const currentComponentElement: JQuery = this.componentContainer.find(`[data-popup-manager-id="${componentId}"]`)

        if (currentComponentElement != null) {
            currentComponentElement.remove()
        }
    }

    private getRouterStateNameByIdReferenceType(idReferenceType: number): string {
        switch (idReferenceType) {
            case Enums.ReferenceType.IdAction: return 'actions'
            case Enums.ReferenceType.IdAlarmGroup: return 'alarm_groups'
            case Enums.ReferenceType.IdAlarmEvent: return 'alarms'
            case Enums.ReferenceType.IdActor: return 'actors'
            case Enums.ReferenceType.IdDeviceConnection: return 'deviceconnections'
            case Enums.ReferenceType.IdDepositoryElement: return 'depositories'
            case Enums.ReferenceType.SerialNbr: return 'devices'
            case Enums.ReferenceType.IdDistributor: return 'distributors'
            case Enums.ReferenceType.IdIssue: return 'issues'
            case Enums.ReferenceType.IdLocation: return 'locations'
            case Enums.ReferenceType.IdMeter: return 'meters'
            case Enums.ReferenceType.IdReport: return 'reports'
            case Enums.ReferenceType.IdRoute: return 'routes'
            case Enums.ReferenceType.IdSimCard: return 'simcards'
            case Enums.ReferenceType.IdTask: return 'tasks'
            case Enums.ReferenceType.IdOperator: return 'operators'
            case Enums.ReferenceType.IdPackage: return 'packages'
            case Enums.ReferenceType.IdPaymentModule: return 'cashier-panel'
            case Enums.ReferenceType.IdConsumer: return 'consumers'
            case Enums.ReferenceType.IdTariff: return 'tariffs'
        }

        LogHelper.error(LayoutDirective.LOG_PREFIX, `Can't get router state name for referencetype: ${idReferenceType}`)
        throw new DOMException()
    }

    private getRouterStateNameBySimaxModuleName(moduleName: Enums.SimaxModuleName): string {
        switch (moduleName) {
            case Enums.SimaxModuleName.Action: return 'actions'
            case Enums.SimaxModuleName.Alarm_Group: return 'alarm_groups'
            case Enums.SimaxModuleName.Alarm: return 'alarms'
            case Enums.SimaxModuleName.Actor: return 'actors'
            case Enums.SimaxModuleName.Device_Connection: return 'deviceconnections'
            case Enums.SimaxModuleName.Depository: return 'depositories'
            case Enums.SimaxModuleName.Device: return 'devices'
            case Enums.SimaxModuleName.Distributor: return 'distributors'
            case Enums.SimaxModuleName.Issue: return 'issues'
            case Enums.SimaxModuleName.Location: return 'locations'
            case Enums.SimaxModuleName.Meter: return 'meters'
            case Enums.SimaxModuleName.Report: return 'reports'
            case Enums.SimaxModuleName.Route: return 'routes'
            case Enums.SimaxModuleName.Sim_Card: return 'simcards'
            case Enums.SimaxModuleName.Task: return 'tasks'
            case Enums.SimaxModuleName.Operator: return 'operators'
            case Enums.SimaxModuleName.Package: return 'packages'
            case Enums.SimaxModuleName.Payment: return 'cashier-panel'
            case Enums.SimaxModuleName.Consumer: return 'consumers'
            case Enums.SimaxModuleName.Tariff: return 'tariffs'
        }

        LogHelper.error(LayoutDirective.LOG_PREFIX, `Can't get router state name for Simax module name: ${moduleName}`)
        throw new DOMException()
    }

    //DO USUNIECIA!!! - po przeniesienie przystich modułów do REST API
    getModuleDetailsEventNameById(id: number) {
        switch (id) {
            case CommonHelper.IdAction: return EventsNames.OPEN_ACTION_DETAILS_POPUP
            case CommonHelper.IdAlarmGroup: return EventsNames.OPEN_ALARM_GROUPS_DETAILS_POPUP
            case CommonHelper.IdAlarmEvent: return EventsNames.OPEN_ALARMS_DETAILS_POPUP
            case CommonHelper.IdActor: return EventsNames.ACTOR_OPEN_DETAILS_POPUP
            case CommonHelper.IdDepositoryElement: return EventsNames.DEPOSITORY_OPEN_DETAILS_POPUP
            case CommonHelper.IdDeviceConnection: return EventsNames.OPEN_DEVICES_DETAILS_POPUP
            case CommonHelper.IdDevice: return EventsNames.OPEN_DEVICES_DETAILS_POPUP
            case CommonHelper.IdDistributor: return EventsNames.DISTRIBUTOR_OPEN_DETAILS_POPUP
            case CommonHelper.IdIssue: return EventsNames.OPEN_ISSUES_DETAILS_POPUP
            case CommonHelper.IdLocation: return EventsNames.OPEN_LOCATION_DETAILS_POPUP
            case CommonHelper.IdMeter: return EventsNames.OPEN_METER_DETAILS_POPUP
            case CommonHelper.IdReport: return EventsNames.REPORT_OPEN_DETAILS_POPUP
            case CommonHelper.IdRoute: return EventsNames.OPEN_ROUTES_DETAILS_POPUP
            case CommonHelper.IdSimCard: return EventsNames.SIM_CARD_OPEN_DETAILS_POPUP
            case CommonHelper.IdTask: return EventsNames.OPEN_TASKS_DETAILS_POPUP
            case CommonHelper.IdOperator: return EventsNames.OPEN_USER_DETAILS_POPUP
        }

        console.log('Problem in getModuleDetailsEventNameById at common helper, please contact with admin')
        throw new DOMException()
    }


    //#region Open Target

    private initializeOpenTarget(): void {
        this.$scope.$on(EventsNames.OPEN_TARGET, (event, ...args: any[]) => {

            const isMeterDef: boolean = this.systemTargetService.openTarget(args[0])

            // Straszna Jałowizna
            if (isMeterDef) {
                let params = args[0].trim().split('-')
                let targetArgs

                if (params) {
                    params.forEach(param => {
                        var par = param.trim().split(' ')
                        if (par && par.length >= 2) {
                            switch (par[0]) {
                                case 'target':
                                case 'args':
                                    targetArgs = param.slice(4).trim()  // 'args'
                                    break;
                            }
                        }
                    })

                }

                if (args[1] != null) this.$scope['schemaOwner'] = args[1]

                this.$scope['showEdit_meterdefs'] = true

                this.$timeout(() => {
                    this.$scope.$broadcast(EventsNames.OPEN_METER_DEFINITIONS_EDIT_POPUP_BY_STRING_OF_PARAMS + this.$scope['detailsPopupId'], targetArgs)
                })
                return
            }
        })
    }

    //#endregion

    //#region Params

    private getParamsToEdit(createEditInitParams: CreateEditInitParams): JQueryPromise<OpDataTypeInGroup[]> {
        return createEditInitParams.customDataTypes && createEditInitParams.customDataTypes.paramsToEdit
            ? this.createDataTypesInGroups(createEditInitParams.customDataTypes.paramsToEdit)
            : DataTypeGroupComponent.getDataTypeInGroupByModule(this.userSession.getDataProvider(), Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PANEL_PARAMS_TO_EDIT, createEditInitParams.moduleName, createEditInitParams.groupReferenceType, createEditInitParams.groupReferenceValue)
    }

    private getGridParams(createEditInitParams: CreateEditInitParams): JQueryPromise<OpDataTypeInGroup[]> {
        return createEditInitParams.customDataTypes && createEditInitParams.customDataTypes.gridParamsToEdit
            ? this.createDataTypesInGroups(createEditInitParams.customDataTypes.gridParamsToEdit)
            : DataTypeGroupComponent.getDataTypeInGroupByModule(this.userSession.getDataProvider(), Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS_TO_EDIT, createEditInitParams.moduleName, createEditInitParams.groupReferenceType, createEditInitParams.groupReferenceValue)
    }

    private getRequiredParams(createEditInitParams: CreateEditInitParams): JQueryPromise<OpDataTypeInGroup[]> {
        return createEditInitParams.customDataTypes && createEditInitParams.customDataTypes.paramsRequired
            ? this.createDataTypesInGroups(createEditInitParams.customDataTypes.paramsRequired)
            : DataTypeGroupComponent.getDataTypeInGroupByModule(this.userSession.getDataProvider(), Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PARAMS_REQUIRED, createEditInitParams.moduleName, createEditInitParams.groupReferenceType, createEditInitParams.groupReferenceValue)
    }

    //#endregion

    //#region Copy

    private getCopySkipParams(createEditInitParams: CreateEditInitParams): JQueryPromise<OpDataTypeInGroup[]> {
        if (createEditInitParams.isCopy) {
            return DataTypeGroupComponent.getDataTypeInGroupByModule(this.userSession.getDataProvider(), Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__COPY_SKIP_PARAMS, createEditInitParams.moduleName)
        }

        return $.Deferred().resolve([]).promise()
    }

    //#endregion

    getModulePermissionsById(id: number) {
        switch (id) {
            case CommonHelper.IdAction: return [Permissions.ACTION_LIST]
            case CommonHelper.IdAlarmGroup: return [Permissions.ALARM_GROUP_LIST]
            case CommonHelper.IdAlarmEvent: return [Permissions.ALARM_LIST]
            case CommonHelper.IdActor: return [Permissions.CONTACT_LIST]
            case CommonHelper.IdConfigurationProfile: return [Permissions.CONFIGURATION_PROFILE_LIST]
            case CommonHelper.IdDeviceConnection: return [Permissions.DEVICE_CONNECTION_LIST]
            case CommonHelper.IdDevice: return [Permissions.DEVICE_LIST]
            case CommonHelper.IdDistributor: return [Permissions.DISTRIBUTOR_LIST]
            case CommonHelper.IdIssue: return [Permissions.ISSUE_LIST]
            case CommonHelper.IdLocation: return [Permissions.LOCATION_LIST]
            case CommonHelper.IdMeter: return [Permissions.METER_LIST]
            case CommonHelper.IdReport: return [Permissions.REPORTS_LIST]
            case CommonHelper.IdRoute: return [Permissions.ROUTE_LIST]
            case CommonHelper.IdSimCard: return [Permissions.SIM_CARD_LIST]
            case CommonHelper.IdTask: return [Permissions.TASK_LIST]
            case CommonHelper.IdOperator: return [Permissions.OPERATOR_LIST]
            case CommonHelper.IdDepositoryElement: return [Permissions.LOCATION_LIST] //!!!!
        }

        console.log('Problem in getModulePermissionsById at common helper, please contact with admin')
        throw new DOMException()
    }
    restrict = 'E'
    template = TEMPLATE
    transclude = true
}